import styled from 'styled-components';

export const SubmitLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
